import { render, staticRenderFns } from "./UserProfileView.vue?vue&type=template&id=4b0c3fa0&"
import script from "./UserProfileView.vue?vue&type=script&lang=ts&"
export * from "./UserProfileView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports